// NOT_TAKEN_REASON_OPTIONS — canonical display list for VitalNotTakenReason.
// Used by web VitalsSection, mobile VitalsSection, and any future consumer.
// DRS B2: absence of a vital reading must carry an explicit reason code.
export const NOT_TAKEN_REASON_OPTIONS = [
    { value: "no_equipment", label: "No equipment" },
    { value: "patient_refused", label: "Patient refused" },
    { value: "patient_asleep", label: "Patient asleep" },
    { value: "clinical_contraindication", label: "Clinical contraindication" },
    { value: "poor_reading", label: "Poor reading" },
    { value: "no_strips", label: "No strips" },
    { value: "not_applicable", label: "Not applicable" },
];
//# sourceMappingURL=not-taken-reasons.js.map